$(document).ready(function() {
    if(!document.querySelector('.GPC0025')) return false;
    $(".GPC0025").find('picture source').remove();
    $(".GPC0025").find('.inside-component .component-wrap').wrap('<div class="inside-inner"></div>');
    //LGEIS-921
    var alignClassDeskTop = $("#alignClassDeskTop").val();
    var alignClassMobile = $("#alignClassMobile").val();
    if($(window).width()<768){
    	$(".GPC0025").find(".banner-box").removeClass(alignClassDeskTop);
        $(".GPC0025").find(".banner-box").addClass(alignClassMobile);
        } else{
            $(".GPC0025").find(".banner-box").removeClass(alignClassMobile);
            $(".GPC0025").find(".banner-box").addClass(alignClassDeskTop);
        }
    $( window ).resize( function() {
        if($(window).width()<768){
        $(".GPC0025").find(".banner-box").removeClass(alignClassDeskTop);
        $(".GPC0025").find(".banner-box").addClass(alignClassMobile);
        } else{
            $(".GPC0025").find(".banner-box").removeClass(alignClassMobile);
            $(".GPC0025").find(".banner-box").addClass(alignClassDeskTop);
        }
    ​});
    //LGEIS-921
    $('.GPC0025').each(function(){
        var $iconblock = $(this).find('.GPC0088');
        if ($iconblock.length) {
            var componentCarouselSimple = {
                $el : null,
                init : function() {
                    this.$el = $iconblock;
                    this.$el.find('.spec-list').not('.none-slide').not('.slick-initialized').each(function(){
                        if($(this).find('.item').length>1) {
                            componentCarouselSimple.runSlick($(this));
                            $(this).parents('.GPC0088').addClass('bindSlick');
                        }
                    });
                    this.$el.find('.spec-list.none-slide').each(function(){
                        if($(this).find('.item').length>2) {
                            $(this).removeClass('none-slide');
                            componentCarouselSimple.runSlick($(this));
                            $(this).parents('.GPC0088').addClass('bindSlick');
                        } else{
                            $(this).addClass('none-slide');
                        }
                    });
                    // this.$el.find('.horizontal').each(function(){
                    //     if($(this).hasClass('horizontal')) {
                    //         console.log($(this).hasClass('horizontal') )
                    //         $(this).parents('.GPC0088').addClass('hor-cp');
                    //     }
                    // });
                },
                runSlick: function($obj) {
                    $obj.slick({
						appendDots:$obj.siblings('.slick-indicator').find('.slick-dot-wrap'),
						responsive: [
							{
								breakpoint: 9999,
								settings: 'unslick'
							},
							{
								breakpoint: 767,
								settings: {
									infinite: false,
									slidesToShow: 1,
									slidesToScroll: 1,
									arrows : false,
									dots: true,
								}
							}
						]
					});
                    $obj.on('afterChange', function(event, slick, currentSlide){
                        //console.log('..');
                    });
                    $obj.on('breakpoint', function(event, slick, breakpoint) {
                        // console.log('breakpoint ' +  breakpoint);
                        if( breakpoint === 767 ) {
                            eventStopOn();
                        }
                        if ( breakpoint === 9999 ) {
                            $obj.off('mousedown.stop touchstart.stop');
                        }
                    });
                    $(window).on('resize',function(){
                        $obj.slick('resize');
                        if( ! mql.maxSm.matches) {
                            $obj.find('.item').removeAttr('role id tabindex aria-describedby aria-hidden');
                        }
                    }).resize();
                    function eventStopOn() {
                        $obj.on('mousedown.stop touchstart.stop', function (e) {
                            e.stopPropagation();
                        });
                    }
                    if( mql.maxSm.matches) {
                        eventStopOn();
                    }
                }
            };
            componentCarouselSimple.init();
        }
    });
});